import React from 'react';
import { API } from 'aws-amplify';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import useSnack from 'hooks/useSnack';
import ScheduleModal from '../components/ScheduleModal';
import { useSelector } from 'react-redux';
import moment from 'moment-timezone';
import { useHistory } from 'react-router-dom';

const Meeting = ({
  title,
  task,
  onBookingComplete,
  onClose,
  student,
  allowCustomSlot,
  availablePeriods,
  includeCoaches,
  includeStudent,
  parents,
  hasCredit
}) => {
  const snack = useSnack();
  const eventId = task.response?.eventId || `fa_${task.id}`;
  const user = useSelector((state) => state.user.user);
  const now = moment.utc();
  const dueInHour = moment.utc(task.due_date).diff(now, 'h', true);
  const history = useHistory();


  
  const redirectToAddons = () =>{
    history.push('/addons');
  }
  

  const onSave = (slot) => {
    const event = {
      id: eventId,
      slot: slot,
      student: {
        email: student.email,
        display_name: student.name,
      },
      recipients: includeStudent ? [{
        email: student.email,
        display_name: student.name,
      }, ...parents] : parents,
      coaches: includeCoaches ? [student.fa_id, student.hc_id, student.lc_id] : [student.fa_id],
      summary: `WeAdmit: Financial Aid Session for ${student.name}`,
    };
    return API.post('api', '/calendar/events', { body: event })
      .then(() => {
        return onBookingComplete(event, task).then(
          () => {
            snack.success('Session booked.');
            onClose();
          },
          (e) => {
            console.log(e);
            snack.error('There was an error. Please try again.');
          },
        );
      })
      .catch((e) => {
        console.log(e);
        snack.error(e.response?.data?.message || e.message);
      });
  };

  if (!student.fa_id) {
    return (
      <Dialog open onClose={onClose}>
        <MuiDialogContent>
          <Typography gutterBottom variant="body2">
            We’re still finding the perfect financial coach for you! Hang tight, and
            reach out to Admin if you need anything in the meantime.
          </Typography>
        </MuiDialogContent>
        <DialogActions>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </Dialog>
    );
  }

  if (includeCoaches && !(student.hc_id && student.lc_id)) {
    return (
      <Dialog open onClose={onClose}>
        <MuiDialogContent>
          <Typography gutterBottom variant="body2">
            We’re still finding the perfect counselors for you! Hang tight, and
            reach out to Admin if you need anything in the meantime.
          </Typography>
        </MuiDialogContent>
        <DialogActions>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </Dialog>
    );
  }

  if (dueInHour <= 24 && user.type === 'student') {
    return (
      <Dialog open onClose={onClose}>
        <MuiDialogContent>
          <Typography gutterBottom variant="body2" color='primary'>
            Meetings cannot be rescheduled less than 24 hours before the start
            time. Please contact your counseling team if you need to reschedule
            the meeting.
          </Typography>
        </MuiDialogContent>
        <DialogActions>
          <Button color='secondary' onClick={onClose}>Close</Button>
        </DialogActions>
      </Dialog>
    );
  }

  if (!hasCredit) {
    return (
      <Dialog open onClose={onClose}>
      <MuiDialogContent>
        <Typography gutterBottom variant="body2" color="primary">
          Oops! It looks like you’re out of credits. Buy more credits to purchase additional credits for this meeting type.
        </Typography>
      </MuiDialogContent>
      <DialogActions>

        <Button onClick={onClose} color="secondary">
          Close
        </Button>
        <Button onClick={redirectToAddons} color="secondary">
        Buy More
        </Button>
      </DialogActions>
    </Dialog>
    );
  }

  return (
    <ScheduleModal
      title={title}
      onSubmit={onSave}
      onClose={onClose}
      duration={30}
      allowCustomSlot={allowCustomSlot}
      studentId={student.id}
      userIds={[student.fa_id]}
      availablePeriods={availablePeriods}
    />
  );
};

export default Meeting;
